import { useQuery } from "@tanstack/react-query";
import { goldBarsService } from "@shared/src/services/goldbars.service";
import type { GoldBarsResponse } from "@sdk/shared/types/goldbars.types";
import { useAuthStore } from "@shared/src/stores/useAuthStore";
import { formatGoldBars } from "@sdk/shared/lib/format";

export function useGoldBars() {
  const { activeAccount } = useAuthStore();

  const { data, error, isLoading, refetch } = useQuery<GoldBarsResponse>({
    queryKey: ["goldBars", activeAccount?.isAuthenticated],
    queryFn: async () => {
      const result = await goldBarsService.getGoldBars();
      if (result.error) throw new Error(result.error);
      if (!result.data) throw new Error("No data received");
      return result.data;
    },
    refetchOnWindowFocus: false,
    enabled: !!activeAccount?.isAuthenticated, // Only fetch when user is authenticated
  });

  return {
    goldBars: formatGoldBars(data?.claimed || 0),
    data,
    isLoading,
    error,
    refresh: refetch,
  };
}
